export const stickyColumnZIndex = 1;
export const stickyHeaderZIndex = 2;
export const stickyHeaderColumnZIndex = 3; // when header cell is sticky as row and column
export const defaultCheckboxWidthPx = 32;
export const outsideElementsColumnWidthPx = 29;
